import Global from '../../store/global-selectors';

export class ScanToVerifyReader {
  constructor({ state }) {
    if (!state) {
      throw new Error(`expected value for state, got: ${state}`);
    }
    this.state = state;
  }

  isFulfillmentPlanVerified({ fulfillmentPlanId }) {
    const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(this.state, { fulfillmentPlanId });
    if (!fulfillmentPlan) {
      return false;
    }

    const isLoading = this.hasLoadingSalesOrder({ fulfillmentPlan });
    if (isLoading) {
      return this.isLocallyVerified();
    }

    return !!(
      fulfillmentPlan &&
      fulfillmentPlan.verificationStatus &&
      fulfillmentPlan.verificationStatus.verifiedByGuid &&
      fulfillmentPlan.verificationStatus.verifiedUtc
    );
  }

  isLocallyVerified() {
    const { verificationStatus } = Global.selectScanToVerifyShipment(this.state) || {};
    const { isVerified } = verificationStatus;
    return !!isVerified;
  }

  hasLoadingSalesOrder({ fulfillmentPlan }) {
    const { salesOrdersFulfilledIds } = fulfillmentPlan;
    const isLoading = (salesOrderId) => Global.selectEntitiesSalesOrderIsLoading(this.state, { salesOrderId });
    return salesOrdersFulfilledIds.some(isLoading);
  }
}
